import React from 'react';
import { connect } from 'react-redux';
import { FreeLayout } from 'Layouts';

import './SupportedDevices.css';

export function SupportedDevices({ supportedDevices }) {
  return <FreeLayout className="supportedDevicesPage" screenName={supportedDevices} />;
}

const mapStateToProps = ({ appConfig: { screens } = {} }) => ({
  supportedDevices: screens.supportedDevices,
});

export const SupportedDevicesContainer = connect(mapStateToProps)(SupportedDevices);
